export function DeviceInfoTable({ values }: { values: Record<string, string | number | undefined> }) {
  return <div className="info-grid">{Object.entries(values).map(([key, value]) => <div className="info-cell" key={key}><span>{key}</span><strong>{value === undefined || value === "" ? "Không có dữ liệu" : String(value)}</strong></div>)}</div>;
}
